import { MyTiers, PostpaidCurrentPlan, PostpaidCurrentPlanItem, PostpaidCurrentPlanView, Tier } from '../models/pricing.model';

export function buildPostpaidPlan(pricing: MyTiers, plan: PostpaidCurrentPlan): PostpaidCurrentPlanView {
  const purchase = plan.purchase;
  const items = (service: string, count: number) =>
    tiersToPostpaidPlanItems(
      pricing.tierDtos.filter(tier => tier.serviceType.toUpperCase() === service),
      count
    );
  return {
    plan,
    tiers: pricing.tierDtos,
    testsCount: purchase
      ? purchase.paidTestCount + purchase.paidTestCountMo + purchase.paidTestCountVoice + (purchase.paidTestCountFlashCall ?? 0)
      : 0,
    itemsMt: items('MT', purchase?.paidTestCount ?? 0),
    itemsMo: items('MO', purchase?.paidTestCountMo ?? 0),
    itemsVoice: items('VOICE', purchase?.paidTestCountVoice ?? 0),
    itemsFlashCall: items('FLASH_CALL', purchase?.paidTestCountFlashCall ?? 0),
  };
}

function tiersToPostpaidPlanItems(tiers: Tier[], tests: number) {
  if (!tiers.length) {
    return [];
  }

  tiers.sort((a, b) => (a.quota > b.quota ? 1 : -1));

  return tiers.map((t, index) => {
    const min = t.quota;
    const max = tiers[index + 1] ? tiers[index + 1].quota : Infinity;
    const item: PostpaidCurrentPlanItem = {
      ratePerTest: t.ratePerUnit,
      commitment: t.commitment,
      usageTests: 0,
      usagePercent: 0,
      min: min,
      max: max,
      isLast: !isFinite(max),
    };
    const usageTests = max - min;
    if (tests >= usageTests) {
      item.usagePercent = 100;
      item.usageTests = item.isLast ? tests : usageTests;
    } else if (tests > 0) {
      item.usageTests = tests;
      item.usagePercent = isFinite(max) ? (tests / usageTests) * 100 : 100;
    }
    tests -= usageTests;
    return item;
  });
}
